import type { BackgroundValue, BgType } from '../types'
import { inputValue, selectValue } from '../utils/input'
import { Field } from './Field'
import { Panel } from './Panel'
import { SliderRow } from './SliderRow'

interface FieldsProps {
  value: BackgroundValue
  onChange: (background: BackgroundValue) => void
}

export function BackgroundFields({ value, onChange }: FieldsProps) {
  const update = (patch: Partial<BackgroundValue>) => {
    onChange({ ...value, ...patch })
  }

  return (
    <>
      <Field label="Type">
        <select value={value.type} onChange={(event) => update({ type: selectValue(event) as BgType })}>
          <option value="solid">Solid</option>
          <option value="linear">Linear</option>
          <option value="radial">Radial</option>
        </select>
      </Field>
      {value.type === 'solid' ? (
        <Field label="Color">
          <input type="color" value={value.color} onInput={(event) => update({ color: inputValue(event) })} />
        </Field>
      ) : (
        <Field label="Colors">
          <input
            type="color"
            value={value.gradientStart}
            onInput={(event) => update({ gradientStart: inputValue(event) })}
          />
          <input
            type="color"
            value={value.gradientEnd}
            onInput={(event) => update({ gradientEnd: inputValue(event) })}
          />
        </Field>
      )}
      {value.type === 'linear' && (
        <SliderRow
          label="Angle"
          min={0}
          max={360}
          value={value.angle}
          display={`${value.angle}°`}
          onChange={(angle) => update({ angle })}
        />
      )}
    </>
  )
}

interface PickerProps extends FieldsProps {
  title?: string
  description?: string
}

export function BackgroundPicker({
  value,
  onChange,
  title = 'Background',
  description = 'Fill the shape. Gradients are recommended — they match the Sailfish style.',
}: PickerProps) {
  return (
    <Panel title={title} description={description}>
      <BackgroundFields value={value} onChange={onChange} />
    </Panel>
  )
}
